import { render } from "./ImageFile.vue?vue&type=template&id=7575a886"
import script from "./ImageFile.vue?vue&type=script&lang=js"
export * from "./ImageFile.vue?vue&type=script&lang=js"
script.render = render

export default script